import authRoles from 'app/auth/authRoles';
import Reports from './Reports';
import SchoolEnrollment from './SchoolEnrollment';
import ParentEnrollment from './ParentEnrollment';
import RevenueReport from './RevenueReport';
import FinancialReport from './Financial/FinancialReport';
import RoyaltyPaymentReport from './RoyaltyPayment/RoyaltyPaymentReport';
import SubscriptionTransactionReports from './SubscriptionTransaction/SubTransReports';
import React from 'react';

const ReportsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/Reports',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Reports />
				</React.Suspense>
			),
		},
		{
			path: '/SchoolEnrollment',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SchoolEnrollment />
				</React.Suspense>
			),
		},
		{
			path: '/SubscriptionTransaction',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SubscriptionTransactionReports />
				</React.Suspense>
			),
		},
		{
			path: '/ParentEnrollment',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ParentEnrollment />
				</React.Suspense>
			),
		},
		{
			path: '/RevenueReport',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RevenueReport />
				</React.Suspense>
			),
		},
		{
			path: '/FinancialReport',
			element: (
				<React.Suspense fallback={<>...</>}>
					<FinancialReport />
				</React.Suspense>
			),
		},
		{
			path: '/RoyaltyPaymentReport',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoyaltyPaymentReport />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default ReportsConfig;
